module.exports = __webpack_public_path__ + "static/media/extra_class_man.dd55b809.svg";